import StatusPill from "../../../components/UI/StatusPill";
import {
  textColor,
  pillColor,
  tooltipTitle,
} from "../../../utils/tableConfigs/VisitsMapping";

export const drawerTableColumns = [
  {
    title: "Activity",
    dataIndex: "activity",
    key: "activity",
    width: 180,
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    width: 125,
    render: (text: string) => (
      <StatusPill
        text={text}
        tooltipTitle={tooltipTitle}
        pillColor={pillColor}
        textColor={textColor}
      />
    ),
    align: "center",
  },
  {
    title: "Time",
    dataIndex: "time",
    key: "time",
    width: 80,
    render: (text: string) => (
      <StatusPill
        text={text}
        tooltipTitle={tooltipTitle}
        pillColor={pillColor}
        textColor={textColor}
      />
    ),
    align: "center",
  },
  {
    title: "Status",
    dataIndex: "activity_status",
    key: "activity_status",
    render: (text: string) => (
      <StatusPill
        text={text}
        tooltipTitle={tooltipTitle}
        pillColor={pillColor}
        textColor={textColor}
      />
    ),
    align: "center",
  },
  {
    title: "Notes",
    dataIndex: "notes",
    key: "notes",
    width: 180,
    render: (text: string) => <p className="wrap-break-word">{text}</p>,
  },
];
